import React from 'react';
import { css } from '@emotion/css';

import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import { Box, Stack, Typography } from '@lyearn/ui';

const opacity30 = css`
  opacity: 0.3;
`;

export const LiveRippleLight = () => (
  <Stack alignItems="center" className="relative h-14 w-14 flex-shrink-0" justifyContent="center">
    <Box className={cn('h-full w-full rounded-full bg-icon-error', opacity30)} />
    <Box className="absolute h-10 w-10 rounded-full bg-icon-error opacity-25 opacity-25" />
    <Box className="absolute h-8 w-8 rounded-full bg-icon-error" />
  </Stack>
);

const Live: React.FC<{ className?: string }> = ({ className }) => {
  const { t } = useTranslation('Common');
  return (
    <Stack
      alignItems="center"
      className={cn('flex h-24 h-24 flex-shrink rounded-4 bg-bg-error px-8', className)}
      justifyContent="center">
      <Box className="relative flex h-8 w-8 items-center justify-center rounded-full bg-bg-primary">
        <Box className="absolute h-16 w-16 rounded-full bg-bg-primary opacity-25" />
      </Box>
      <Typography className="ms-8" color="text-text-white" variant="label-caps">
        {t('Common:Live')}
      </Typography>
    </Stack>
  );
};

export default Live;
